import { GoogleTagManager } from "@next/third-parties/google"
import { useSelector } from "react-redux"

export default function Gtm({ gtmId = null }) {
	const isAnalyticsAccepted = useSelector((state) => state.showCookies.isAnalyticsAccepted)

	if (!gtmId || !isAnalyticsAccepted) return null

	return <GoogleTagManager gtmId={gtmId} />
}